import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px custom-dark-bg rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = { class: "form-label fw-bolder text-gray-900 fs-6" }
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = { class: "form-label fw-bolder text-gray-900 fs-6" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_14 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_15 = { class: "indicator-label" }
const _hoisted_16 = { class: "indicator-progress" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      onSubmit: _ctx.onSubmitForgotPassword,
      id: "kt_login_password_reset_form",
      "validation-schema": _ctx.forgotPassword
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.create_your_new_access_password`)), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.fill_in_the_new_access_data`)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.your_password`)), 1),
          _createVNode(_component_Field, {
            class: "form-control form-control-solid",
            type: "password",
            placeholder: _ctx.$t(`${_ctx.currentLanguage}.auth.create_your_new_access_password`),
            name: "password",
            autocomplete: "off"
          }, null, 8, ["placeholder"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.auth.confirm_password`)), 1),
          _createVNode(_component_Field, {
            class: "form-control form-control-solid",
            type: "password",
            placeholder: _ctx.$t(`${_ctx.currentLanguage}.auth.type_your_password_again`),
            name: "password_confirmation",
            autocomplete: "off"
          }, null, 8, ["placeholder"]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.reset`)), 1),
            _createElementVNode("span", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.profile.please_wait`)) + " ... ", 1),
              _hoisted_17
            ])
          ], 512),
          _createVNode(_component_router_link, {
            to: "/sign-in",
            class: "btn btn-lg btn-light-primary fw-bolder"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.cancel`)), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}